import React from 'react';
import {Text, RichText} from '@sitecore-jss/sitecore-jss-react';

class ContactUsDropdownCn extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeContent: null,
			preSelected: null,
			isToggleOn: false,
		};
		this.handleClick = this.handleClick.bind(this);
	}
	componentDidMount() {
		const initial = this.props.fields.initialAddress;
		const initialAddress =!!initial? (
			<React.Fragment>
				<RichText field={initial}/>
			</React.Fragment>
		) : null;
		this.setState({
			activeContent: initialAddress,
		});
	}
	handleClick() {
		this.setState(prevState => ({
			isToggleOn: !prevState.isToggleOn
		}));
	}

	handleChange = e => {
		const {fields} = this.props;
		const defaultOption = {fields: null};
		const newData = typeof e === 'string'
			? (fields.options.find(option => option.id === e) || defaultOption).fields
			: (fields.options.find(option => option.id === e.target.value) || defaultOption).fields;
		const content = !!newData ? (
			<React.Fragment>
				<RichText field={newData.description}/>
			</React.Fragment>
		) : null;

		this.setState({
			activeContent: content,
			isToggleOn: false,
			preSelected:newData.title.value,
			...!!newData ? {} : { preSelected: null },	// if newData does not exists, change preSelected to null
		});
	};

	render() {
		const {activeContent, preSelected,isToggleOn} = this.state;
		const {fields} = this.props;

		return (
			<div className="contact-us-dropdown-cn form-dropdown-box-cn">
				<div className="contacCRegion">
					<div className="contact-us-container l-padding">
						<Text field={fields.title} tag="h2"/>
						<div className="el-select">
							<div className="el-input el-input--suffix" onClick={this.handleClick}>
								<input type="text" autocomplete="off" placeholder={fields.placeholder.value}
									   value={preSelected}
									   className="el-input__inner" readonly="readonly"/>
									<span className="el-input__suffix">
										<span className="el-input__suffix-inner">
											<i className={isToggleOn ? 'el-select__caret el-input__icon el-icon-arrow-up' : 'el-select__caret el-input__icon el-icon-arrow-down'}></i>
										</span>
									</span>
							</div>
							<div className={isToggleOn ? 'on el-option' : 'el-option'}>
								<div className="el-option-scroll">
									<ul>
									{fields.options.map(option => {
										return !!preSelected ? (
											<li key={option.id} id={option.id} className={option.fields.title.value === preSelected ? 'selected' : ''} onClick={this.handleChange.bind(this,option.id)}>
												{option.fields.title.value}
												<span className="firstLetter">{option.fields.firstLetter.value} </span>
											</li>
											) : (
											<li key={option.id} id={option.id} onClick={this.handleChange.bind(this,option.id)}>
												{option.fields.title.value}
												<span className="firstLetter">{option.fields.firstLetter.value} </span>
											</li>
											);
									})}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="contacDetail">
					<div className="contact-us-container l-padding">
						{activeContent}
					</div>
				</div>
			</div>
		);
	}
}

export default ContactUsDropdownCn;
